<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="7">
        <v-card title="Editar Perfil" text="Completa tu Perfil" ref="form">
          <!-- <v-form ref=form> -->
          <v-container py-0>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-text class="text-xs-center">
                    <!-- <h6 class="category text-gray font-weight-thin mb-3">{{ user.experticie }}</h6>  name of the center of organizatio -->
                    <h1
                      class="card-title font-weight-light"
                    >{{ currentUser.first_name }} {{ currentUser.last_name }}</h1>
                    <p class="card-description font-weight-light">{{ currentUser.about_me }}</p>
                    <v-row justify="space-between"></v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Compañía " ref="company" v-model="currentUser.company" />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  class="purple-input"
                  label="Rol"
                  ref="role"
                  v-model="currentUser.role"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="currentUser.email.primary"
                  label="Email"
                  class="purple-input"
                  ref="email"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="currentUser.first_name"
                  label="Nombres"
                  class="purple-input"
                  ref="first_name"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="currentUser.last_name"
                  label="Apellidos"
                  class="purple-input"
                  ref="last_name"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="currentUser.address"
                  label="Dirección"
                  class="purple-input"
                  ref="address"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="currentUser.city"
                  label="Ciudad"
                  class="purple-input"
                  ref="city"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="currentUser.country"
                  label="País"
                  class="purple-input"
                  ref="country"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="currentUser.about_me"
                  class="purple-input"
                  label="Acerca de mí"
                  ref="about_me"
                />
              </v-col>

              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <v-combobox
                      v-model="user.skills"
                      :items="user.skills"
                      label="Habilidades"
                      multiple
                      chips
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Financiaciones</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-col cols="12">
                        <v-card
                          v-for="data in user.fundings"
                          :key="data.title_fproject + data.date"
                        >
                          <v-card-text v-if="data.title_fproject">
                            <strong>Título:</strong>
                            <b>{{ data.title_fproject }}</b>
                          </v-card-text>
                          <v-card-text v-if="data.organization">
                            <strong>Organización:</strong>
                            <b>{{ data.organization }}</b>
                          </v-card-text>
                          <v-card-text v-if="data.date">
                            <strong>Fecha:</strong>
                            <b>{{ data.date }}</b>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-spacer></v-spacer>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Trabajos</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-col cols="12">
                        <v-card
                          v-for="data in user.experience"
                          :key="data.organization + data.initialDate"
                        >
                          <v-card-text v-if="data.initialDate">
                            <strong>Fecha de Inicio:</strong>
                            <b>{{ data.initialDate }}</b>
                          </v-card-text>
                          <v-card-text v-if="data.roleTitle">
                            <strong>Rol:</strong>
                            <b>{{data.roleTitle }}</b>
                          </v-card-text>
                          <v-card-text v-if="data.organization">
                            <strong>Organización:</strong>
                            <b>{{ data.organization }}</b>
                          </v-card-text>
                          <v-card-text v-if="data.city">
                            <strong>Ciudad:</strong>
                            <b>{{ data.city }}</b>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-spacer></v-spacer>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Estudios</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card
                        v-for="data in user.education"
                        :key="data.organization + data.role_title + data.city"
                      >
                        <v-col cols="12">
                          <v-card>
                            <v-card-text v-if="data.organization">
                              <strong>Organización:</strong>
                              <b>{{ data.organization }}</b>
                            </v-card-text>
                            <v-card-text v-if="data.city">
                              <strong>Ciudad:</strong>
                              <b>{{ data.city }}</b>
                            </v-card-text>
                            <v-card-text v-if="data.role_title">
                              <strong>Rol:</strong>
                              <b>{{ data.role_title }}</b>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-spacer></v-spacer>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Proyectos</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card v-for="data in user.projects" :key="data.title + data.date">
                        <v-col cols="12">
                          <v-card>
                            <v-card-text v-if="data.title">
                              <strong>Título:</strong>
                              <b>{{ data.title }}</b>
                            </v-card-text>
                            <v-card-text v-if="data.type">
                              <strong>Tipo:</strong>
                              <b>{{ data.type }}</b>
                            </v-card-text>
                            <v-card-text v-if="data.date">
                              <strong>Fecha de publicación:</strong>
                              <b>{{ data.date }}</b>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <v-col>
                <v-row align="center" justify="center">
                  <v-col text-xs-right align="left">
                    <v-btn
                      class="mx-0 white--text"
                      @click="save_information"
                      color="light-blue"
                    >Actualizar Perfil</v-btn>
                  </v-col>

                  <v-col text-xs-right align="right">
                    <v-btn
                      v-if="enable"
                      class="mx-0 white--text"
                      color="light-blue"
                      @click="conectarORCID()"
                    >Enlazar con Orcid</v-btn>
                    <v-btn
                      v-else
                      class="mx-0 white--text"
                      color="light-blue"
                      @click="desconectarORCID()"
                    >Desconectar de Orcid</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <!-- </v-form> -->
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="loading">{{ text }}</v-snackbar>
    <v-snackbar v-model="ready">{{ textReady }}</v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as firebase from "firebase";
import axios from "axios";
import { orcidRedirectUri } from "../../main";
export default {
  data() {
    return {
      dialog: false,
      providedPassword: "",
      enable: true,
      loading: false,
      ready: false,
      text: "Cargando los datos, espere",
      textReady: "",
      currentUser: {
        usertype: "",
        first_name: "",
        last_name: "",
        company: "",
        role: "",
        about_me: "",
        address: "",
        email: "",
        city: "",
        country: "",
        orcid_id: "",
        skills: [],
        tags: [],
        experience: [],
        education: [],
        projects: [],
        fundings: [],
        recommendedProjects: []
      },
      skills: null,
      fundings: null
    };
  },

  created() {
    const _this = this;
    _this.readProfile();
    const orcidCode = this.$route.query.code;

    // eslint-disable-next-line no-console
    console.log(orcidCode);
    const id = firebase.auth().currentUser.uid;

    if (!orcidCode) {
      firebase
        .firestore()
        .collection("User")
        .doc(id)
        .onSnapshot(function(doc) {
          let user = doc.data();
          _this.currentUser.first_name = user.first_name;
          _this.currentUser.last_name = user.last_name;
          _this.currentUser.address = user.address;
          _this.currentUser.about_me = user.about_me;
          _this.currentUser.city = user.city;
          _this.currentUser.country = user.country;
          _this.currentUser.company = user.company;
          _this.currentUser.role = user.role;
          _this.currentUser.email = user.email;
          if (user.orcid_id) {
            _this.enable = false;
          }
        });
    } else {
      var body = new URLSearchParams();

      body.append("client_id", "APP-6T2U5INEDICQNRFN");
      body.append("client_secret", "aa4a4568-8134-4af9-bb82-8fa717ea577c");
      body.append("grant_type", "authorization_code");
      body.append("code", orcidCode);
      body.append("redirect_uri", orcidRedirectUri + "/user-profile");

      axios
        .post(
          "https://cors-anywhere.herokuapp.com/https://orcid.org/oauth/token",
          body
        )
        .then(response => {
          // eslint-disable-next-line no-console
          console.log("respuesta" + JSON.stringify(response));

          var userToken = response.data.access_token;

          // eslint-disable-next-line no-console
          console.log("ORCID Token: " + userToken);

          var orcidId = response.data.orcid;

          // eslint-disable-next-line no-console
          console.log("ORCID-iD: " + orcidId);
          const currentUserId = firebase.auth().currentUser.uid;
          var cont = 0;
          firebase
            .firestore()
            .collection("User")
            .where("orcid_id", "==", orcidId)
            .get()
            .then(function(querysnap) {
              querysnap.forEach(() => {
                cont++;
              });
            })
            .catch(() => {
              //eslint-disable-next-line no-console
              console.log("Ocurrió un error en query");
            })
            .finally(() => {
              if (cont > 0) {
                _this.textReady =
                  "Ya existe una cuenta asociada con este OrcidID";
                _this.ready = true;
                _this.$router.push({ name: "profile" });
                location.reload();
              } else {
                firebase
                  .firestore()
                  .collection("User")
                  .doc(currentUserId)
                  .update({ orcid_id: orcidId })
                  .then(() => {
                    //eslint-disable-next-line no-console
                    console.log("OrcidId Actualizado!");
                    _this.conectarORCID();
                  });
              }
            });
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions("user", ["readProfile"]),

    save_information() {
      const _this = this;
      const userInfo = {
        first_name: _this.currentUser.first_name,
        last_name: _this.currentUser.last_name,
        company: _this.currentUser.company,
        role: _this.currentUser.role,
        about_me: _this.currentUser.about_me,
        address: _this.currentUser.address,
        email: _this.currentUser.email,
        city: _this.currentUser.city,
        country: _this.currentUser.country
      };

      this.$store.dispatch("user/modifyUser", userInfo).then(() => {
        this.textReady = "Su perfil se ha actualizado";
        this.ready = true;
      });
    },

    setDataWithOrcid(
      experience,
      education,
      projects,
      about_me,
      first_name,
      last_name,
      country,
      fundings
    ) {
      var _this = this;
      var convert = require("xml2js");
      const currentUserId = firebase.auth().currentUser.uid;
      // eslint-disable-next-line no-console
      console.log(currentUserId);
      _this.loading = true;
      firebase
        .firestore()
        .collection("User")
        .doc(currentUserId)
        .get()
        .then(doc => {
          let tmp = doc.data();
          let orcid_id = tmp.orcid_id;
          if (orcid_id == undefined) {
            window.location.href =
              "https://orcid.org/oauth/authorize?client_id=APP-6T2U5INEDICQNRFN&response_type=code&scope=/authenticate&redirect_uri=" +
              orcidRedirectUri +
              "/user-profile";
          } else {
            _this.loading = true;
            let config = {
              headers: {
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "POST",
                "Access-Control-Allow-Headers": "*"
              }
            };
            var body = new URLSearchParams();
            body.append("client_id", "APP-6T2U5INEDICQNRFN");
            body.append(
              "client_secret",
              "aa4a4568-8134-4af9-bb82-8fa717ea577c"
            );
            body.append("grant_type", "client_credentials");
            body.append("scope", "/read-public");
            axios
              .post(
                "https://cors-anywhere.herokuapp.com/https://orcid.org/oauth/token",
                body,
                config
              )
              .then(response => {
                // eslint-disable-next-line no-console
                console.log("Success", response);
                const configGet = {
                  headers: {
                    Accept: "application/vnd.orcid+xml",
                    Authorization: "Bearer",
                    //"Access token": response.access_token,
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "POST",
                    "Access-Control-Allow-Headers": "*"
                  }
                };
                var idData = new URLSearchParams();
                idData.append("Access token", response.access_token);
                axios
                  .get(
                    "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                      orcid_id +
                      "/employments",
                    idData,
                    configGet
                  )
                  .then(response => {
                    convert.parseString(response.data, function(err, result) {
                      // eslint-disable-next-line no-console
                      console.log(result);
                      var employments =
                        result["activities:employments"][
                          "employment:employment-summary"
                        ];
                      if (employments.length > 0) {
                        for (let i = 0; i < employments.length; i++) {
                          const employment = {};
                          if (
                            employments[i]["common:start-date"][0][
                              "common:day"
                            ][0]
                          ) {
                            employment.initialDate =
                              employments[i]["common:start-date"][0][
                                "common:day"
                              ][0] +
                              "-" +
                              employments[i]["common:start-date"][0][
                                "common:month"
                              ][0] +
                              "-" +
                              employments[i]["common:start-date"][0][
                                "common:year"
                              ][0];
                          }
                          if (employments[i]["employment:role-title"][0]) {
                            employment.roleTitle =
                              employments[i]["employment:role-title"][0];
                          }
                          if (
                            employments[i]["employment:organization"][0][
                              "common:name"
                            ][0]
                          ) {
                            employment.organization =
                              employments[i]["employment:organization"][0][
                                "common:name"
                              ][0];
                          }
                          if (
                            employments[i]["employment:organization"][0][
                              "common:address"
                            ][0]["common:city"][0]
                          ) {
                            employment.city =
                              employments[i]["employment:organization"][0][
                                "common:address"
                              ][0]["common:city"][0] +
                              ", " +
                              employments[i]["employment:organization"][0][
                                "common:address"
                              ][0]["common:region"][0] +
                              ", " +
                              employments[i]["employment:organization"][0][
                                "common:address"
                              ][0]["common:country"][0];
                          }
                          experience[i] = employment;
                        }
                      }
                    });
                  })
                  .catch(error => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                    _this.loading = false;
                  })
                  .finally(() => {
                    axios
                      .get(
                        "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                          orcid_id +
                          "/biography",
                        idData,
                        configGet
                      )
                      .then(response => {
                        convert.parseString(response.data, function(
                          err,
                          result
                        ) {
                          // eslint-disable-next-line no-console
                          console.log(result);
                          var biography =
                            result["personal-details:biography"][
                              "personal-details:content"
                            ];
                          if (biography) {
                            about_me = biography[0];
                          }
                        });
                      })
                      .catch(error => {
                        // eslint-disable-next-line no-console
                        console.log(error);
                        _this.loading = false;
                      })
                      .finally(() => {
                        axios
                          .get(
                            "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                              orcid_id +
                              "/educations",
                            idData,
                            configGet
                          )
                          .then(response => {
                            convert.parseString(response.data, function(
                              err,
                              result
                            ) {
                              // eslint-disable-next-line no-console
                              console.log(result);
                              var educations =
                                result["activities:educations"][
                                  "education:education-summary"
                                ];
                              if (educations.length > 0) {
                                for (let i = 0; i < educations.length; i++) {
                                  const ed = {};
                                  if (
                                    educations[i]["education:organization"][0][
                                      "common:name"
                                    ][0]
                                  ) {
                                    ed.organization =
                                      educations[i][
                                        "education:organization"
                                      ][0]["common:name"][0];
                                  }
                                  if (
                                    educations[i]["education:organization"][0][
                                      "common:address"
                                    ][0]["common:city"][0]
                                  ) {
                                    ed.city =
                                      educations[i][
                                        "education:organization"
                                      ][0]["common:address"][0][
                                        "common:city"
                                      ][0] +
                                      ", " +
                                      educations[i][
                                        "education:organization"
                                      ][0]["common:address"][0][
                                        "common:region"
                                      ][0] +
                                      ", " +
                                      educations[i][
                                        "education:organization"
                                      ][0]["common:address"][0][
                                        "common:country"
                                      ][0];
                                  }
                                  if (
                                    educations[i]["education:role-title"][0]
                                  ) {
                                    ed.role_title =
                                      educations[i]["education:role-title"][0];
                                  }
                                  education[i] = ed;
                                }
                              }
                            });
                          })
                          .catch(error => {
                            // eslint-disable-next-line no-console
                            console.log(error);
                            _this.loading = false;
                          })
                          .finally(() => {
                            axios
                              .get(
                                "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                                  orcid_id +
                                  "/works",
                                idData,
                                configGet
                              )
                              .then(response => {
                                convert.parseString(response.data, function(
                                  err,
                                  result
                                ) {
                                  // eslint-disable-next-line no-console
                                  console.log(result);
                                  var activities =
                                    result["activities:works"][
                                      "activities:group"
                                    ];
                                  if (activities.length > 0) {
                                    for (
                                      let i = 0;
                                      i < activities.length;
                                      i++
                                    ) {
                                      const act = {};
                                      if (
                                        activities[i]["work:work-summary"][0][
                                          "work:title"
                                        ][0]["common:title"][0]
                                      ) {
                                        act.title =
                                          activities[i]["work:work-summary"][0][
                                            "work:title"
                                          ][0]["common:title"][0];
                                      }
                                      if (
                                        activities[i]["work:work-summary"][0][
                                          "work:type"
                                        ][0]
                                      ) {
                                        act.type =
                                          activities[i]["work:work-summary"][0][
                                            "work:type"
                                          ][0];
                                      }
                                      if (
                                        activities[i]["work:work-summary"][0][
                                          "common:publication-date"
                                        ][0]["common:day"][0]
                                      ) {
                                        act.date =
                                          activities[i]["work:work-summary"][0][
                                            "common:publication-date"
                                          ][0]["common:day"][0] +
                                          "-" +
                                          activities[i]["work:work-summary"][0][
                                            "common:publication-date"
                                          ][0]["common:month"][0] +
                                          "-" +
                                          activities[i]["work:work-summary"][0][
                                            "common:publication-date"
                                          ][0]["common:year"][0];
                                      }
                                      projects[i] = act;
                                    }
                                  }
                                });
                              })
                              .catch(error => {
                                // eslint-disable-next-line no-console
                                console.log(error);
                                _this.loading = false;
                              })
                              .finally(() => {
                                axios
                                  .get(
                                    "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                                      orcid_id +
                                      "/personal-details",
                                    idData,
                                    configGet
                                  )
                                  .then(response => {
                                    convert.parseString(response.data, function(
                                      err,
                                      result
                                    ) {
                                      // eslint-disable-next-line no-console
                                      console.log(result);
                                      var details =
                                        result[
                                          "personal-details:personal-details"
                                        ]["personal-details:name"];
                                      if (details.length > 0) {
                                        first_name =
                                          details[0][
                                            "personal-details:given-names"
                                          ][0];
                                        last_name =
                                          details[0][
                                            "personal-details:family-name"
                                          ][0];
                                      }
                                    });
                                  })
                                  .catch(error => {
                                    // eslint-disable-next-line no-console
                                    console.log(error);
                                    _this.loading = false;
                                  })
                                  .finally(() => {
                                    axios
                                      .get(
                                        "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                                          orcid_id +
                                          "/address",
                                        idData,
                                        configGet
                                      )
                                      .then(response => {
                                        convert.parseString(
                                          response.data,
                                          function(err, result) {
                                            // eslint-disable-next-line no-console
                                            console.log(result);
                                            var add =
                                              result["address:addresses"][
                                                "address:address"
                                              ];
                                            if (add.length > 0) {
                                              country =
                                                add[0]["address:country"][0];
                                            }
                                          }
                                        );
                                      })
                                      .catch(error => {
                                        // eslint-disable-next-line no-console
                                        console.log(error);
                                        _this.loading = false;
                                      })
                                      .finally(() => {
                                        axios
                                          .get(
                                            "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                                              orcid_id +
                                              "/fundings",
                                            idData,
                                            configGet
                                          )
                                          .then(response => {
                                            convert.parseString(
                                              response.data,
                                              function(err, result) {
                                                // eslint-disable-next-line no-console
                                                console.log(result);
                                                var financiamientos =
                                                  result["activities:fundings"][
                                                    "activities:group"
                                                  ];
                                                for (
                                                  let i = 0;
                                                  i < financiamientos.length;
                                                  i++
                                                ) {
                                                  const funding = {};
                                                  if (
                                                    financiamientos[i][
                                                      "funding:funding-summary"
                                                    ][0]["funding:title"][0][
                                                      "common:title"
                                                    ][0]
                                                  ) {
                                                    funding.title_fproject =
                                                      financiamientos[i][
                                                        "funding:funding-summary"
                                                      ][0]["funding:title"][0][
                                                        "common:title"
                                                      ][0];
                                                  }
                                                  if (
                                                    financiamientos[i][
                                                      "funding:funding-summary"
                                                    ][0][
                                                      "common:start-date"
                                                    ][0]["common:month"][0]
                                                  ) {
                                                    funding.date =
                                                      financiamientos[i][
                                                        "funding:funding-summary"
                                                      ][0][
                                                        "common:start-date"
                                                      ][0]["common:month"][0] +
                                                      "-" +
                                                      financiamientos[i][
                                                        "funding:funding-summary"
                                                      ][0][
                                                        "common:start-date"
                                                      ][0]["common:year"][0];
                                                  }
                                                  if (
                                                    financiamientos[i][
                                                      "funding:funding-summary"
                                                    ][0][
                                                      "funding:organization"
                                                    ][0]["common:name"][0]
                                                  ) {
                                                    funding.organization =
                                                      financiamientos[i][
                                                        "funding:funding-summary"
                                                      ][0][
                                                        "funding:organization"
                                                      ][0]["common:name"][0];
                                                  }
                                                  fundings[i] = funding;
                                                  // eslint-disable-next-line no-console
                                                  console.log(funding);
                                                }
                                              }
                                            );
                                          })
                                          .catch(error => {
                                            // eslint-disable-next-line no-console
                                            console.log(error);
                                            _this.loading = false;
                                          })
                                          .finally(() => {
                                            firebase
                                              .firestore()
                                              .collection("User")
                                              .doc(currentUserId)
                                              .update({
                                                experience: experience,
                                                last_name: last_name,
                                                first_name: first_name,
                                                projects: projects,
                                                education: education,
                                                country: country,
                                                about_me: about_me,
                                                fundings: fundings
                                              })
                                              .then(() => {
                                                // eslint-disable-next-line no-console
                                                console.log(
                                                  "Actualizando datos"
                                                );
                                                _this.loading = false;
                                              })
                                              .finally(() => {
                                                this.$router.push({
                                                  name: "profile"
                                                });
                                                location.reload();
                                              });
                                          });
                                      });
                                  });
                              });
                          });
                      });
                  });
              })
              .catch(e => {
                // eslint-disable-next-line no-console
                console.log("Error", e);
              });
          }
        });
    },

    desconectarORCID() {
      var _this = this;
      _this.loading = true;
      var id = firebase.auth().currentUser.uid;
      const ref = firebase
        .firestore()
        .collection("User")
        .doc(id);
      ref
        .update({
          orcid_id: firebase.firestore.FieldValue.delete()
        })
        .then(() => {
          _this.loading = false;
          location.reload();
        })
        .catch(err => {
          _this.loading = false;
          // eslint-disable-next-line no-console
          console.log("Error al borrar orcidId: " + err);
          _this.text = "Ocurrió un error, vuelva a intentarlo";
          _this.loading = true;
        });
    },

    conectarORCID() {
      // TODO: The logic for the conecction
      var experience = {};
      var education = {};
      var projects = {};
      var fundings = {};
      var about_me = "";
      var first_name = "";
      var last_name = "";
      var country = "";
      this.setDataWithOrcid(
        experience,
        education,
        projects,
        about_me,
        first_name,
        last_name,
        country,
        fundings
      );
    }
  },

  computed: {
    ...mapState("user", ["user"])
  }
};
</script>